import { ref } from 'vue'
import { defineStore } from 'pinia'
import travelApi from '@/api/travelApi'

export const useTravelConfigStore = defineStore('travelConfigStore', () => {

  const travelMessages = ref<UserTravelMessages>({})
  const travelDocumentInstructions = ref<UserDocumentInstruction[]>([])
  const travelPages = ref<UserTravelPage[]>([])

  const setTravel = (travelId: number) => {
    travelApi.getTravelMessages(travelId).then((response) => {
      travelMessages.value = response.data;
    }).catch(() => {
      // ignore error, messages are not critical and will be fetched again on next travel load
    });

    travelApi.getTravelDocumentInstructions(travelId).then((response) => {
      travelDocumentInstructions.value = response.data;
    }).catch(() => {
      // ignore error, messages are not critical and will be fetched again on next travel load
    });

    travelApi.getTravelPages(travelId).then((response) => {
      travelPages.value = response.data;
    }).catch(() => {
      // ignore error, messages are not critical and will be fetched again on next travel load
    });
  }

  return { setTravel, travelMessages, travelDocumentInstructions, travelPages }
})
